// ── wave.js — рисунок звуковой дорожки плеера ───────────────────────────────
// Один рисовальщик на все случаи: заглушка до загрузки (fake), настоящая форма волны,
// перерисовка при смене темы. Раньше это был один и тот же код в трёх местах Player.js.
//
// Обычно — тонкие столбики цвета P.waveColor (сыгранную часть показывает подложка).
// Тема с waveStyle: 'eq' — пиксельный эквалайзер, как на игровом автомате, —
// столбики 3 px через 1 px, высота ступеньками, цвет по громкости (тихо — синий, потом
// зелёный, золото, громко — красный; P.waveBands). Обычный рисунок приглушён, «горячий»
// (hot) — ярко и со свечением: им плеер закрашивает уже сыгранную часть.
//
//   paintWave(canvas, peaks, P)                       — дорожка
//   paintWave(canvas, peaks, P, { hot: true, width }) — сыгранная часть (waveStyle 'eq')
//   paintWave(canvas, null, P, { fake: true })        — заглушка до загрузки

const BANDS = ['#009dff', '#4bc292', '#fda200', '#fe5f55'];

// Значение дорожки в точке x из peaks (растянуты на всю ширину с интерполяцией).
function sample(peaks, x, W) {
  const n = peaks.length;
  if (!n) return 0;
  const srcI = (x / W) * n;
  const lo = Math.min(n - 1, Math.floor(srcI));
  const hi = Math.min(lo + 1, n - 1);
  return (peaks[lo] || 0) * (1 - (srcI - lo)) + (peaks[hi] || 0) * (srcI - lo);
}
// Заглушка: правдоподобная «речь» из синусов.
const fakeValue = (x) => 0.3 + 0.35 * Math.abs(Math.sin(x * 0.09)) + 0.2 * Math.abs(Math.sin(x * 0.23 + 1.3)) + 0.12 * Math.abs(Math.sin(x * 0.5 + 0.7));

export function paintWave(canvas, peaks, P, { hot = false, fake = false, width } = {}) {
  if (!canvas || (!peaks && !fake)) return;
  const W = Math.max(1, Math.round(width || canvas.offsetWidth || 640));
  const H = Math.max(1, canvas.offsetHeight || 64);
  const dpr = window.devicePixelRatio || 1;
  canvas.width = W * dpr;
  canvas.height = H * dpr;
  if (width) canvas.style.width = `${W}px`;
  const c = canvas.getContext('2d');
  if (!c) return;
  c.setTransform(dpr, 0, 0, dpr, 0, 0);
  c.clearRect(0, 0, W, H);
  const value = fake ? fakeValue : (x) => sample(peaks, x, W);

  // Эквалайзер пользователь забраковал (17.10: «плеер выглядит ужасно, верни как было») —
  // ни у одной темы его сейчас нет; код оставлен, включается waveStyle: 'eq' в палитре.
  if (P.waveStyle !== 'eq') {
    c.globalAlpha = fake ? 0.32 : 1;
    c.fillStyle = P.waveColor;
    for (let x = 0; x < W; x++) {
      const bH = Math.max(2, value(x) * H * (fake ? 0.86 : 0.88));
      c.fillRect(x, (H - bH) / 2, 1.5, bH);
    }
    c.globalAlpha = 1;
    return;
  }

  const STEP = 4;
  const BAR = 3;
  const Q = 2;
  const bands = P.waveBands || BANDS;
  // Громкость — относительно самого громкого места: тогда и тихая запись переливается всеми цветами.
  let max = 0;
  if (!fake) for (let x = 0; x < W; x += 2) max = Math.max(max, value(x));
  const norm = fake ? 1 : max > 0 ? 1 / max : 1;
  for (let x = 0; x < W; x += STEP) {
    let v = 0;
    for (let k = 0; k < STEP; k++) v = Math.max(v, value(x + k));
    v = Math.min(1, v * norm);
    const bH = Math.max(Q, Math.round((v * H * 0.86) / Q) * Q);
    const col = bands[Math.min(bands.length - 1, Math.floor(v * bands.length * 0.999))];
    c.fillStyle = col;
    c.globalAlpha = fake ? 0.4 : hot ? 1 : 0.55;
    c.shadowColor = col;
    c.shadowBlur = hot ? 6 : 0;
    c.fillRect(x, Math.round((H - bH) / 2), BAR, bH);
  }
  c.globalAlpha = 1;
  c.shadowBlur = 0;
}
